module.exports = __webpack_public_path__ + "img/pintuan.1970df71.png";